import React, { useEffect } from 'react';
// eslint-disable-next-line xing/no-extraneous-import
import { useQuery } from '@apollo/client';

import { Column, Row } from '@xingternal/xing-grid';
import { usePageContext, LAZY_LOADING_TYPE_SCROLL } from '@xingternal/pages-common';

import ModuleError from '../News/ModuleError';
import { NewsContainer } from '../News';
import styles from './NewsDetail.css';

import NEWS_SUBMODULE_QUERY from './NewsSubModuleQuery.graphql';
import { LoadingSkeleton } from '../NewsItem';

const NewsDetail = () => {
  const {pageContext} = usePageContext();
  const { pageId} = pageContext;
  const { data = {}, loading, error, refetch } = useQuery(
    NEWS_SUBMODULE_QUERY,
    {
      variables: { id: pageId, moduleType: 'news' },
      notifyOnNetworkStatusChange: true,
      errorPolicy: 'all',
      onError: () => <ModuleError refetch={refetch} />,
    }
  );

  // scroll to top only on the first render
  useEffect(() => {
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
  }, []);

  if (error || data?.properties === null) {
    return <ModuleError refetch={refetch} />;
  }

  return (
    <div className={styles.wrapper}>
      {loading && (
        <Row>
          <Column sizeDesktop={10} offsetDesktop={1} size={12}>
            <LoadingSkeleton smallActor={true} />
          </Column>
        </Row>
      )}
      {!loading && (
        <NewsContainer
          moduleProperties={data.entityPageModule.properties}
          loadingSkeletonCount={3}
          showHeadline={false}
          showSubpageLinks={false}
          isDetailPage={true}
          lazyLoadingType={LAZY_LOADING_TYPE_SCROLL}
        />
      )}
    </div>
  );
};

export default NewsDetail;
